<div *ngIf="!pais; else divPais" class="alert alert-info text-dark">
  Espere por favor...
</div>

<ng-template #divPais>
  <div class="row">
    <div class="col-12">
      <h1>
        País:
        <small>{{ pais.name }}</small>
      </h1>
    </div>
  </div>

  <div class="row mb-2">
    <div class="col-md-4 mb-2 mb-md-0">
      <h3>Bandera</h3>
      <img [src]="pais.flag" class="img-fluid" [alt]="pais.name" />
    </div>

    <div class="col mt-4 mt-md-0">
      <h3>Informacion</h3>

      <ul class="list-group">
        <li class="list-group-item">
          <strong>Población: </strong> {{ pais.population | number }}
        </li>
        <li class="list-group-item">
          <strong>Código numérico: </strong> {{ pais.numericCode }}
        </li>
        <li class="list-group-item">
          <strong>Código alpha: </strong> {{ pais.alpha3Code }}
        </li>
      </ul>
    </div>
  </div>

  <div class="row mb-5">
    <div class="col mt-4 mt-md-0">
      <h3>Traducciones</h3>
    </div>
    <div class="col-12">
      <span class="badge bg-primary mr-2 p-2 mb-2">{{
        pais.translations.es
      }}</span>
      <span class="badge bg-primary mr-2 p-2 mb-2">{{
        pais.translations.de
      }}</span>
      <span class="badge bg-primary mr-2 p-2 mb-2">{{
        pais.translations.br
      }}</span>
      <span class="badge bg-primary mr-2 p-2 mb-2">{{
        pais.translations.fr
      }}</span>
      <span class="badge bg-primary mr-2 p-2 mb-2">{{
        pais.translations.pt
      }}</span>
      <span class="badge bg-primary mr-2 p-2 mb-2">{{
        pais.translations.nl
      }}</span>
      <span class="badge bg-primary mr-2 p-2 mb-2">{{
        pais.translations.hr
      }}</span>
      <span class="badge bg-primary mr-2 p-2 mb-2">{{
        pais.translations.it
      }}</span>
      <span class="badge bg-primary mr-2 p-2 mb-2">{{
        pais.translations.fa
      }}</span>
      <span class="badge bg-primary mr-2 p-2 mb-2">{{
        pais.translations.ja
      }}</span>
    </div>
  </div>

  <!-- <pre>
    {{ pais | json }}
  </pre> -->
</ng-template>
